module.exports = __webpack_public_path__ + "static/media/movies.f2a5af60.png";